import {
    server
} from "@/api";

const prefix = 'api/products'

const adminPrefix = 'api/admin/products'

export const admin = {
    create: async (product) => {
        return await server().post(adminPrefix, product, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    all: async (params) => {
        return await server().get(`${adminPrefix}/all`, { params });
    },
    get: async (id, params = {}) => {
        return await server().get(`${adminPrefix}/${id}`, { params });
    },
    paginate: async (params) => {
        return await server().get(adminPrefix, { params });
    },
    update: async (id, product) => {
        return await server().post(`${adminPrefix}/${id}`, product, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    edit: async (id, params = {}) => {
        return await server().get(`${adminPrefix}/${id}/edit`, { params });
    },
    destroy: async (id) => {
        return await server().delete(`${adminPrefix}/${id}`);
    }
}



export const create = async (product) => {
    return await server().post(prefix, product, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const all = async (params) => {
    return await server().get(`${prefix}/all`, { params });
}

export const edit = async (id, params = {}) => {
    return await server().get(`${prefix}/${id}/edit`, { params });
}

export const get = async (id, params = {}) => {
    return await server().get(`${prefix}/${id}`, { params });
}

export const paginate = async (params) => {
    return await server().get(prefix, { params });
}

export const update = async (id, product) => {
    return await server().post(`${prefix}/${id}`, product, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export const destroy = async (id) => {
    return await server().delete(`${prefix}/${id}`);
}

export const destroyMultiple = async (ids) => {
    return await server().delete(`${prefix}/bulk`, {
        data: { ids }
    });
}

const productApi = {
    create,
    get,
    all,
    update,
    paginate,
    edit,
    destroy,
    destroyMultiple,
    admin
}

export default productApi;